export default __webpack_public_path__ + "static/media/QTrip-static.034da2f7.png";